import {uts} from './functions';
import {getConfig} from './config.js';

export function userIsAgent() {
    const selectedIdentity = JSON.parse(localStorage.getItem('selectedIdentity'));
    const userCategoryId = (selectedIdentity != null) ? selectedIdentity.userCategoryId : 0;

    return userCategoryId == 4010100000032;
}

export function userIsLoggedIn() {
    const config = getConfig();
    const loginDatas = localStorage.getItem('loginDatas');
    const loginLastUpdated = localStorage.getItem('loginLastUpdated');
    let expired = false;
    
    if (loginLastUpdated == null || loginLastUpdated == '') {
        expired = true;
    }
    if (!expired) {
        let diff = uts() - loginLastUpdated;
        if (diff > config.app.loginValidInSeconds) {
            expired = true;
        }
    }

    if (loginDatas == '' || loginDatas == null || expired) {
        return false;
    }

    return true;
}